
<div class="col-xs-12" *ngIf="isLostInTransitOrder">
  <button class="btn btn-danger btn-sm" *ngIf="!isLossAlreadyClaimed" (click)="markLossClaimed()" [disabled]="disableEdit">Mark Loss Claimed</button>
  <button class="btn btn-success btn-sm" *ngIf="isLossAlreadyClaimed">Loss Claimed</button>
</div>